import { generateUtilityClasses } from "@mui/material";
const toolbarRootName = "TidalToolbarRoot";
const toolbarRootClasses = generateUtilityClasses(toolbarRootName, [
  "divider",
  "root"
]);
export {
  toolbarRootClasses,
  toolbarRootName
};
//# sourceMappingURL=classes.js.map
